import { RefObject, useEffect } from "react";

/**
 * Fires `callback` whenever the user clicks outside the given `ref`.
 * Cleans up the listener automatically on unmount.
 */
export const useClickOutside = <T extends HTMLElement>(
    ref: RefObject<T>,
    callback: (event: MouseEvent) => void
): void => {
    useEffect(() => {
        const handleMouseDown = (event: MouseEvent) => {
            if (ref.current && !ref.current.contains(event.target as Node)) {
                callback(event);
            }
        };

        document.addEventListener("mousedown", handleMouseDown);
        return () => document.removeEventListener("mousedown", handleMouseDown);
    }, [ref, callback]);
};
